import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MetricCard as StyledMetricCard, MetricCardHeader, MetricCardContent, MetricTitle, MetricValue, MetricSubtitle, IconWrapper, TrendWrapper, TrendText } from './Styles';
import type { MetricCardProps } from './types';
import { faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons';


const MetricCard: React.FC<MetricCardProps> = ({
  title,
  subtitle,
  value,
  icon,
  color,
  trend,
  trendValue,
  onClick,
  isSelected = false,
}) => {
  return (
    <StyledMetricCard
      isSelected={isSelected}
      cardColor={color}
      onClick={onClick}
      hoverable={!!onClick}
    >
      <MetricCardHeader>
        <MetricCardContent>
          <MetricTitle>{title}</MetricTitle>
          <MetricValue color={color}>{value}</MetricValue>
          {subtitle && <MetricSubtitle>{subtitle}</MetricSubtitle>}
        </MetricCardContent>
        <IconWrapper color={color}>
          <FontAwesomeIcon icon={icon} />
        </IconWrapper>
      </MetricCardHeader>
      {trend && trendValue && (
        <TrendWrapper>
          <TrendText trend={trend}>
            <FontAwesomeIcon icon={trend === 'up' ? faArrowUp : faArrowDown} />
            {trendValue}
          </TrendText>
        </TrendWrapper>
      )}
    </StyledMetricCard>
  );
};

export default MetricCard;
